import { useSelector } from 'react-redux'
import { stateSelector } from '~/selectors'

const useStoreState = (reducerNameAsKey) => {
  return useSelector(stateSelector(reducerNameAsKey))
}

export default useStoreState
